/**
 * @generated SignedSource<<6b561062c1d2befc0bbf09c84dad071c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type User_getRoles_Query$variables = {};
export type User_getRoles_Query$data = {
  readonly roles: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type User_getRoles_Query = {
  response: User_getRoles_Query$data;
  variables: User_getRoles_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Role",
    "kind": "LinkedField",
    "name": "roles",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "User_getRoles_Query",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "User_getRoles_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c18d0a4717ea6abf52020309d97b7de1",
    "id": null,
    "metadata": {},
    "name": "User_getRoles_Query",
    "operationKind": "query",
    "text": "query User_getRoles_Query {\n  roles {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3fcdfd33f920be18021092a96ddad4c";

export default node;
